<template>
  <div id="work-in-progress">
    <div class="main-container">
      <h2 class="progress__heading heading--md heading--underlined">
        SURVIVE THE APOCALYPSE
      </h2>
      <p class="progress__description">
        The game world offers
        <strong>thousands of generated maps</strong> spread across
        <strong>16 distinctive biomes</strong> and
        <strong>28 Raid locations</strong>. Explore them all, but watch out for
        <strong>bandits</strong> roaming abandoned military bases,
        <strong>zombies</strong> wandering the country, and hungry
        <strong>wildlife</strong> ready to tear you to shreds!
      </p>
      <p class="progress__description">
        Use advanced <strong>stealth</strong> mechanics,
        <strong>snipe</strong> your enemies from long range, or simply
        <strong>bash</strong> your way through danger to succeed on your
        mission.
      </p>
      <!--  <p class="progress__description">
                We&rsquo;d really love it if you helped our team by offering any
                <strong>tips or opinions</strong> you might have on how we can improve the game.
            </p>
            <p class="progress__description">Did a zombie glitch through the wall?</p>
            <p class="progress__description">Is a particular gun way too powerful?</p>
            <p class="progress__description">
                Don&rsquo;t hold back -
                <strong>let us know what you really think!</strong> Your feedback is invaluable and will help shape the
                game&rsquo;s full release. Check out this
                <a class="color--red external-link" href="https://minidayz.com/blog/how-to-report-a-bug" rel="nofollow"
                    >short article</a
                >
                on the best way to get in touch and let us know your thoughts.
            </p> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "WorkInProgress"
};
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/vars";

#work-in-progress {
  padding: 7em 0 4em;
  .progress__heading {
    margin-bottom: em(120, 31);

    @media (max-width: $screen-lg-down) {
      margin-bottom: 1.5em;
    }
  }
  .progress__description {
    font-family: "Metron Book", sans-serif;
    font-size: 1.6em;
    font-weight: 400;
    line-height: 1.7;
    letter-spacing: 0.035em;
  }
}
</style>
